import { useMemo } from "react";

import { useUpdateDataContext } from "@/contexts/UpdateDataContext";
import {
  canAccessUsersPage,
  canEditIEB,
  canManageAllUsers,
  canManageEvents,
  canAccessLogs,
} from "@/utils/permissionsHandler";

export const useNavLinks = (user) => {
  const { workflow } = useUpdateDataContext();

  return useMemo(() => {
    const membershipLinks = {
      horizontalLinks: [
        { name: "Dashboard", url: "/membership/dashboard" },
        {
          name: "Update Data",
          url: "/membership/update-data/select-file",
        },
        {
          name: "User Guide",
          url: "/user-guide/political-data-upload",
        },
      ],
      verticalLinks: [
        {
          name: "My Account",
          url: "/membership/account/profile",
        },
      ],
    };
    const politicalLinks = {
      horizontalLinks: [
        { name: "Dashboard", url: "/political/dashboard" },
        {
          name: "Upload Volunteer Data",
          url: "/political/update-data/select-file",
        },
        {
          name: "User Guide",
          url: "/user-guide/political-data-upload",
        },
      ],
      verticalLinks: [],
    };

    if (workflow === "political") {
      if (canManageAllUsers(user)) {
        politicalLinks.verticalLinks.push({
          name: "Manage Users",
          url: "/political/users",
        });
      }
      if (canManageEvents(user)) {
        politicalLinks.verticalLinks.push({
          name: "Manage Events",
          url: "/political/manage-events",
        });
      }
      if (canAccessLogs(user)) {
        politicalLinks.verticalLinks.push({
          name: "Logs",
          url: "/show-logs",
        });
      }
      return politicalLinks;
    } else {
      if (canAccessUsersPage(user)) {
        membershipLinks.verticalLinks.push({
          name: "Manage Users",
          url: "/membership/users",
        });
      }
      if (canEditIEB(user)) {
        membershipLinks.verticalLinks.push({
          name: "IEB Page",
          url: "/membership/ieb",
        });
      }
      if (canAccessLogs(user)) {
        membershipLinks.verticalLinks.push({
          name: "Logs",
          url: "/show-logs",
        });
      }
      return membershipLinks;
    }
  }, [workflow, user]);
};
